export const reducedAddress = (address = '') => {
    if (!address || address.length < 12) return address || '';
    return address.slice(0, 6) + '...' + address.slice(-4);
};

export const copyText = async (value) => {
    if (!value) return false;
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            return true;
        }
    } catch (err) {
        // fallback below
    }
    try {
        const area = document.createElement('textarea');
        area.value = value;
        area.setAttribute('readonly', '');
        area.style.position = 'absolute';
        area.style.left = '-9999px';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
        return true;
    } catch (err) {
        return false;
    }
};
